const urls = {
  production: {
    apiUrl: 'https://order.webshop.elsevier.com/login-status.cfm',
    loginUrl: 'https://order.webshop.elsevier.com/login.cfm?returnUri={returnUri}&prompt=none',
    myDeskUrl: 'https://authorservices.elsevier.com/account',
    myAuthorServices: 'http://order.webshop.elsevier.com/customer/my-author-services.cfm',
    myProfile: 'https://order.webshop.elsevier.com/customer/myprofile.cfm',
    logout: 'https://order.webshop.elsevier.com/logout.cfm',
    phdUploadLink: 'https://authorservices.elsevier.com/languageediting/phd',
    phdPlusUploadLink: 'https://authorservices.elsevier.com/languageediting/phd_plus',
    aboutWebShopLink: 'https://order.webshop.elsevier.com',
    articleOffprintsBuyLink: 'https://order.webshop.elsevier.com/myarticleservices/offprints/',
    articlePostersBuyLink: 'https://order.webshop.elsevier.com/myarticleservices/articlepublications/articleposter/',
    journalCoverPosterBuyLink: 'https://order.webshop.elsevier.com/myarticleservices/articlepublications/journalcoverposter/',
    journalIssuesBuyLink: 'https://order.webshop.elsevier.com/myarticleservices/journalissues/',
    publicationRecognitionBuyLink: 'https://order.webshop.elsevier.com/myarticleservices/publication-recognition/',
    academicInfoGraphicsBuyLink: 'https://order.webshop.elsevier.com/illustration-services/academic-infographics/project_create_step1.cfm',
    basicLanguageEditingUploadLink: 'https://authorservices.elsevier.com/languageediting/standard',
    latexLanguageEditingUploadLink: 'https://authorservices.elsevier.com/languageediting/latex',
    plusLanguageEditingUploadLink: 'https://authorservices.elsevier.com/languageediting/plus',
    translationServiceUploadLink: 'https://authorservices.elsevier.com/languagetranslation/translation',
    translationExpressServiceUploadLink: 'https://authorservices.elsevier.com/languageediting/express',
    scientificIllustrationBuyLink: 'https://order.webshop.elsevier.com/illustration-services/illustrations/project_create_step1.cfm',
    journalissues: 'https://journalissues.elsevier.com/journals/',
    /**
     * external urls
     */
    blog: 'https://scientific-publishing.webshop.elsevier.com/',
    blogCn: 'https://cn.scientific-publishing.webshop.elsevier.com/',
    termsAndConditions: 'https://www.elsevier.com/legal/elsevier-website-terms-and-conditions/',
    help: 'https://service.elsevier.com/app/home/supporthub/webshop/',
    contact: 'https://service.elsevier.com/app/contact/supporthub/webshop/',
    privacy: 'https://www.elsevier.com/legal/privacy-policy/',
    cookiesGoogleAnalyticsPrivacy: 'https://www.google.com/analytics/learn/privacy.html',
    cookiesDoubleClickPrivacy: 'https://support.google.com/dfp_premium/answer/2839090?hl=en',
    cookiesAdobeLiveDocs: 'https://livedocs.adobe.com/coldfusion/7/htmldocs/wwhelp/wwhimpl/js/html/wwhelp.htm?href=00001159.htm',
    cookiesGoogleAnalyticsAdvertisersPolicy: 'https://support.google.com/analytics/bin/answer.py?hl=en&answer=2700409',
    cookiesFacebookPolicy: 'https://www.facebook.com/policies/cookies/',
    cookiesOptimizelyPolicy: 'https://www.optimizely.com/privacy/',
    groupDealsContact: 'mailto:webshop_support@elsevier.com',
    afterPublicationMendely: 'https://www.mendeley.com/universal-claim/?routeTo=/profiles/me&referrer=md',
    afterPublictionResearcherAcademy: 'https://researcheracademy.elsevier.com/',
    journalFinder: 'https://journalfinder.elsevier.com/',
    mendely: 'https://www.mendeley.com/',
    mendelyReference: 'https://www.mendeley.com/reference-management/reference-manager/',
    researchAcademy: 'https://researcheracademy.elsevier.com/',
    citationPluginMendely: 'https://www.mendeley.com/reference-management/citation-plugin/',
    facebook: 'https://www.facebook.com/elsevierauthorservices/',
    linkedin: 'https://www.linkedin.com/company/elsevier-authorservices',
    twitter: 'https://twitter.com/ElsevierConnect/',
    youtube: 'https://www.youtube.com/channel/UCeg3r-A2cTOUNHB1vvKBT9g',
    pinterest: 'https://pinterest.com/elsevierauthorservices/',
    localeCn: ' https://webshop.elsevier.cn',    
    localeGlobal: 'https://webshop.elsevier.com',
    dealsVideo: 'https://www.youtube.com/embed/gHLFOgaUbl4?rel=0&autoplay=1',
    dealsVideoCn: '//player.bilibili.com/player.html?aid=756267364&bvid=BV1Wr4y1M7Bc&cid=288416207&page=1',
    /**
     * external scripts
     */
    cookielaw: '3ef68bec-76cb-4cd4-9c50-e52f562251da',    
    adobedtm: 'https://assets.adobedtm.com/4a848ae9611a/3b7120286094/launch-e7a51022b5ec.min.js',
  },
  staging: {
    apiUrl: 'https://order.webshop.elsevier-estreet.staging.ritense.com/login-status.cfm', // yes, must point to prod
    loginUrl: 'https://order.webshop.elsevier-estreet.staging.ritense.com/login.cfm?returnUri={returnUri}&prompt=none',
    myDeskUrl: 'https://accauthorservices.authorservices-np.elsevier.com/account ',
    myAuthorServices: 'http://order.webshop.elsevier.com/customer/my-author-services.cfm',
    myProfile: 'https://order.webshop.elsevier-estreet.staging.ritense.com/customer/myprofile.cfm',
    logout: 'https://order.webshop.elsevier-estreet.staging.ritense.com/logout.cfm',
    phdUploadLink: 'https://authorservices.elsevier.com/languageediting/phd',
    phdPlusUploadLink: 'https://authorservices.elsevier.com/languageediting/phd_plus',
    aboutWebShopLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com',
    articleOffprintsBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/myarticleservices/offprints/',
    articlePostersBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/myarticleservices/articlepublications/articleposter/',
    journalCoverPosterBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/myarticleservices/articlepublications/journalcoverposter/',
    journalIssuesBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/myarticleservices/journalissues/',
    publicationRecognitionBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/myarticleservices/publication-recognition/',
    academicInfoGraphicsBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/illustration-services/academic-infographics/project_create_step1.cfm',
    basicLanguageEditingUploadLink: 'https://authorservices.elsevier.com/languageediting/standard',
    latexLanguageEditingUploadLink: 'https://authorservices.elsevier.com/languageediting/latex',
    plusLanguageEditingUploadLink: 'https://authorservices.elsevier.com/languageediting/plus',
    translationServiceUploadLink: 'https://authorservices.elsevier.com/languagetranslation/translation',
    translationExpressServiceUploadLink: 'https://authorservices.elsevier.com/languageediting/express',
    scientificIllustrationBuyLink: 'https://order.webshop.elsevier-estreet.staging.ritense.com/illustration-services/illustrations/project_create_step1.cfm',
    journalissues: 'https://journalissues.elsevier.com/journals/',
    /**
     * external urls
     */
    localeCn: 'http://order.webshop.elsevier-estreet.staging.ritense.com',
    localeGlobal: 'http://order.webshop.elsevier-estreet.staging.ritense.com',
    /**
     * external scripts
     */
    cookielaw: '3ef68bec-76cb-4cd4-9c50-e52f562251da-test',
    adobedtm: 'https://assets.adobedtm.com/4a848ae9611a/3b7120286094/launch-bfb0bdf10da9-staging.min.js',
  },
}

// prod object is "blueprint", this makes sure that the staging url object has the same properties
const stagingUrls = Object.assign({}, urls.production, urls.staging)

const getConfig = () => {
  switch (process.env.GATSBY_ACTIVE_ENV) {
    case 'production':
      return urls.production
    case 'development':
    case 'staging':
    default:
      return stagingUrls
  }
}

/**
 * Provides links for keys. *Dont* query the urls objects directly.
 * @param linkKey
 * @returns string
 */
export default function getLink(linkKey) {
  if (!linkKey) {
    return null
  }
  const url = getConfig()[linkKey]
  if (!url) {
    // eslint-disable-next-line no-console
    console.error(new Error(`No url for key ${linkKey}`))
    return null
  }

  return url
}
